var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "28", height: "28", viewBox: "0 0 28 28", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Stroke 1"
    ),
    React.createElement("path", { d: "M7.52 10.95a21.247 21.247 0 0 0 1.796 2.923c.67.914 1.4 1.771 2.192 2.573a20.827 20.827 0 0 0 2.543 2.192c.903.66 1.851 1.253 2.846 1.78l2.035-1.851a1.57 1.57 0 0 1 .442-.305c.172-.081.36-.122.563-.122.081 0 .162.01.243.03.081.021.153.041.213.062.771.263 1.588.467 2.451.609.862.142 1.75.213 2.664.213h.03c.406 0 .751.136 1.036.41.284.275.426.615.426 1.02v5.054c0 .406-.142.746-.426 1.02-.285.274-.63.411-1.036.411-3.389 0-6.57-.64-9.544-1.918-2.973-1.279-5.571-3.03-7.794-5.251-2.223-2.223-3.978-4.826-5.267-7.81C1.645 9.007 1 5.82 1 2.431c0-.386.142-.72.426-1.005A1.41 1.41 0 0 1 2.462 1h5.053c.386 0 .72.142 1.005.426.284.285.426.62.426 1.005v.06c0 .914.071 1.807.213 2.68.142.872.355 1.725.64 2.557a1.587 1.587 0 0 1-.075.883 1.135 1.135 0 0 1-.32.457L7.52 10.95z", stroke: "#F96204", strokeWidth: "2", fill: "none", fillRule: "evenodd", strokeLinejoin: "round" })
  );
});